<div class="chat-dialog__backdrop" (click)="close()"></div>

<div class="chat-dialog chat-forward" role="dialog" aria-modal="true" aria-label="Forward message">
  <header class="chat-dialog__header">
    <h3>Forward message</h3>
    <button type="button" (click)="close()" aria-label="Close"><i class="pi pi-times"></i></button>
  </header>

  <div class="chat-dialog__body">
    <!-- What is being sent, so the user can tell at a glance they picked the right bubble -->
    <div class="chat-forward__preview" *ngIf="message() as source">
      <span class="chat-forward__preview-from">{{ source.sender.name }}</span>
      <p class="chat-forward__preview-text">{{ previewText }}</p>
      <span class="chat-forward__preview-meta" *ngIf="attachmentCount">
        <i class="pi pi-paperclip"></i>
        {{ attachmentCount === 1 ? '1 attachment' : attachmentCount + ' attachments' }}
      </span>
    </div>

    <div class="chat-dialog__search">
      <i class="pi pi-search"></i>
      <input type="text" [ngModel]="search()" (ngModelChange)="search.set($event)" placeholder="Search people or groups…" aria-label="Search" />
    </div>

    <ul class="chat-dialog__people chat-forward__list">
      <li
        *ngFor="let target of filtered(); trackBy: trackByTarget"
        (click)="toggle(target)"
        [class.is-selected]="isSelected(target)"
        role="checkbox"
        [attr.aria-checked]="isSelected(target)">
        <span class="chat-dialog__check" [class.is-on]="isSelected(target)"><i class="pi pi-check" *ngIf="isSelected(target)"></i></span>

        <span class="chat-forward__group-icon" *ngIf="target.kind === 'group'"><i class="pi pi-users"></i></span>
        <app-chat-avatar
          *ngIf="target.kind === 'person'"
          [name]="target.name"
          [avatar]="target.avatar_url"
          [status]="target.status"
          [size]="28"></app-chat-avatar>

        <span class="chat-forward__identity">
          <span class="chat-dialog__person-name">{{ target.name }}</span>
          <span class="chat-forward__subtitle" *ngIf="target.subtitle">{{ target.subtitle }}</span>
        </span>
      </li>

      <li class="chat-dialog__none" *ngIf="!filtered().length">No people or groups match that search.</li>
    </ul>

    <!-- Stated before sending, not discovered afterwards: a forward re-uploads every file -->
    <p class="chat-forward__note" *ngIf="attachmentNote">
      <i class="pi pi-info-circle"></i>
      {{ attachmentNote }}
    </p>
  </div>

  <footer class="chat-dialog__footer chat-forward__footer">
    <span class="chat-forward__count">{{ selectedCount() ? selectedCount() + ' selected' : 'Pick at least one' }}</span>
    <div class="chat-forward__actions">
      <button type="button" class="chat-forward__cancel" (click)="close()" [disabled]="store.forwarding()">Cancel</button>
      <button type="button" class="chat-forward__send" (click)="send()" [disabled]="!selectedCount() || store.forwarding()">
        <i class="pi pi-spin pi-spinner" *ngIf="store.forwarding()"></i>
        {{ store.forwarding() ? 'Sending…' : 'Send' }}
      </button>
    </div>
  </footer>
</div>
